import React from 'react';
import { classNames } from '../../utils/format';

export default function Tabs({ tabs, value, onChange }) {
  return (
    <div className="tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={value === tab.value}
          className={classNames('tabs__tab', value === tab.value && 'is-active')}
          onClick={() => onChange(tab.value)}
        >
          {tab.icon && <span aria-hidden>{tab.icon}</span>}
          <span>{tab.label}</span>
          {tab.count !== undefined && <span className="tabs__count">{tab.count}</span>}
        </button>
      ))}
    </div>
  );
}
